import React, { useState, useEffect } from "react";
import axios from "axios";

const BASE = "https://dailydish.in/api/admin";

const CHANNEL_LABELS = {
  flyer: "Flyer",
  standie: "Standie",
  lift_banner: "Lift Banner",
  whatsapp: "WhatsApp",
  door_tag: "Door Tag",
  alpine: "Alpine (Apartment)",
  hiranandani: "Hiranandani (Apartment)",
  organic: "Organic",
  refer: "Referral",
};

const AcquisitionStats = () => {
  const [stats, setStats] = useState([]);
  const [dateRows, setDateRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [channelFilter, setChannelFilter] = useState("");

  const fetchStats = async () => {
    try {
      setLoading(true);
      const [summaryRes, datewiseRes] = await Promise.all([
        axios.get(`${BASE}/acquisition-stats`, {
          params: { startDate, endDate },
        }),
        axios.get(`${BASE}/acquisition-stats-datewise`, {
          params: { startDate, endDate, channel: channelFilter || undefined },
        }),
      ]);
      if (summaryRes.data.success) setStats(summaryRes.data.stats);
      if (datewiseRes.data.success) setDateRows(datewiseRes.data.rows);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const totalVisits = stats.reduce((sum, s) => sum + s.visits, 0);
  const totalRegistered = stats.reduce((sum, s) => sum + s.registered, 0);

  return (
    <div
      style={{
        padding: "20px",
        fontFamily: "Inter, sans-serif",
        background: "#f8f9fa",
        minHeight: "100vh",
      }}
    >
      <div
        style={{
          background: "linear-gradient(135deg, #6B8E23 0%, #4a6e12 100%)",
          borderRadius: "16px",
          padding: "24px 28px",
          color: "#fff",
          marginBottom: "24px",
        }}
      >
        <h2 style={{ margin: 0, fontSize: "22px", fontWeight: "700" }}>
          📣 Marketing Channel Stats
        </h2>
        <p style={{ margin: "4px 0 0", opacity: 0.85, fontSize: "14px" }}>
          Scans vs. registrations per channel (flyer, standie, lift banner,
          WhatsApp, door tag...)
        </p>
      </div>

      <div
        style={{
          display: "flex",
          gap: "12px",
          flexWrap: "wrap",
          alignItems: "flex-end",
          marginBottom: "20px",
        }}
      >
        <div>
          <div
            style={{
              fontSize: "12px",
              color: "#666",
              fontWeight: "600",
              marginBottom: "6px",
            }}
          >
            From
          </div>
          <input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            style={{
              padding: "10px 14px",
              borderRadius: "10px",
              border: "1.5px solid #ddd",
            }}
          />
        </div>
        <div>
          <div
            style={{
              fontSize: "12px",
              color: "#666",
              fontWeight: "600",
              marginBottom: "6px",
            }}
          >
            To
          </div>
          <input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            style={{
              padding: "10px 14px",
              borderRadius: "10px",
              border: "1.5px solid #ddd",
            }}
          />
        </div>
        <div>
          <div
            style={{
              fontSize: "12px",
              color: "#666",
              fontWeight: "600",
              marginBottom: "6px",
            }}
          >
            Channel
          </div>
          <select
            value={channelFilter}
            onChange={(e) => setChannelFilter(e.target.value)}
            style={{
              padding: "10px 14px",
              borderRadius: "10px",
              border: "1.5px solid #ddd",
            }}
          >
            <option value="">All Channels</option>
            {Object.entries(CHANNEL_LABELS).map(([value, label]) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>
        </div>
        <button
          onClick={fetchStats}
          style={{
            padding: "10px 20px",
            borderRadius: "10px",
            border: "none",
            background: "#6B8E23",
            color: "#fff",
            fontWeight: "700",
            cursor: "pointer",
          }}
        >
          Apply
        </button>
      </div>

      <div
        style={{
          background: "#fff",
          borderRadius: "16px",
          overflow: "hidden",
          boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
          border: "1px solid #e8f0d8",
        }}
      >
        {loading ? (
          <div style={{ textAlign: "center", padding: "60px", color: "#888" }}>
            Loading...
          </div>
        ) : stats.length === 0 ? (
          <div style={{ textAlign: "center", padding: "60px", color: "#888" }}>
            No scans recorded yet.
          </div>
        ) : (
          <table
            style={{
              width: "100%",
              borderCollapse: "collapse",
              fontSize: "13px",
            }}
          >
            <thead>
              <tr
                style={{
                  background:
                    "linear-gradient(135deg, #f6faf0 0%, #edf5e1 100%)",
                  borderBottom: "2px solid #d4e8b0",
                }}
              >
                {["Channel", "Scans", "Registered", "Conversion"].map((h) => (
                  <th
                    key={h}
                    style={{
                      padding: "14px 16px",
                      textAlign: "left",
                      fontWeight: "700",
                      color: "#3a5a0e",
                      fontSize: "12px",
                      textTransform: "uppercase",
                    }}
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {stats.map((s, idx) => (
                <tr
                  key={s.channel}
                  style={{
                    borderBottom: "1px solid #f0f5e8",
                    background: idx % 2 === 0 ? "#fff" : "#fafcf7",
                  }}
                >
                  <td
                    style={{
                      padding: "12px 16px",
                      fontWeight: "600",
                      color: "#2c2c2c",
                    }}
                  >
                    {CHANNEL_LABELS[s.channel] || s.channel}
                  </td>
                  <td style={{ padding: "12px 16px" }}>{s.visits}</td>
                  <td style={{ padding: "12px 16px" }}>{s.registered}</td>
                  <td style={{ padding: "12px 16px" }}>
                    {s.conversionRate === null ? "—" : `${s.conversionRate}%`}
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr style={{ borderTop: "2px solid #d4e8b0", fontWeight: "700" }}>
                <td style={{ padding: "12px 16px" }}>Total</td>
                <td style={{ padding: "12px 16px" }}>{totalVisits}</td>
                <td style={{ padding: "12px 16px" }}>{totalRegistered}</td>
                <td style={{ padding: "12px 16px" }}>
                  {totalVisits > 0
                    ? `${((totalRegistered / totalVisits) * 100).toFixed(1)}%`
                    : "—"}
                </td>
              </tr>
            </tfoot>
          </table>
        )}
      </div>

      <h3
        style={{
          margin: "28px 0 12px",
          fontSize: "16px",
          color: "#3a5a0e",
          fontWeight: "700",
        }}
      >
        📅 Day-wise Breakdown
      </h3>
      <div
        style={{
          background: "#fff",
          borderRadius: "16px",
          overflow: "hidden",
          boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
          border: "1px solid #e8f0d8",
        }}
      >
        {loading ? (
          <div style={{ textAlign: "center", padding: "60px", color: "#888" }}>
            Loading...
          </div>
        ) : dateRows.length === 0 ? (
          <div style={{ textAlign: "center", padding: "60px", color: "#888" }}>
            No scans recorded yet.
          </div>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "13px",
              }}
            >
              <thead>
                <tr
                  style={{
                    background:
                      "linear-gradient(135deg, #f6faf0 0%, #edf5e1 100%)",
                    borderBottom: "2px solid #d4e8b0",
                  }}
                >
                  {["Date", "Channel", "Scans", "Registered", "Conversion"].map(
                    (h) => (
                      <th
                        key={h}
                        style={{
                          padding: "14px 16px",
                          textAlign: "left",
                          fontWeight: "700",
                          color: "#3a5a0e",
                          fontSize: "12px",
                          textTransform: "uppercase",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {h}
                      </th>
                    ),
                  )}
                </tr>
              </thead>
              <tbody>
                {dateRows.map((r, idx) => (
                  <tr
                    key={`${r.date}_${r.channel}`}
                    style={{
                      borderBottom: "1px solid #f0f5e8",
                      background: idx % 2 === 0 ? "#fff" : "#fafcf7",
                    }}
                  >
                    <td style={{ padding: "12px 16px", whiteSpace: "nowrap" }}>
                      {r.date}
                    </td>
                    <td
                      style={{
                        padding: "12px 16px",
                        fontWeight: "600",
                        color: "#2c2c2c",
                      }}
                    >
                      {CHANNEL_LABELS[r.channel] || r.channel}
                    </td>
                    <td style={{ padding: "12px 16px" }}>{r.visits}</td>
                    <td style={{ padding: "12px 16px" }}>{r.registered}</td>
                    <td style={{ padding: "12px 16px" }}>
                      {r.conversionRate === null ? "—" : `${r.conversionRate}%`}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default AcquisitionStats;
